module.exports = __webpack_public_path__ + "static/media/tshirt3new.3a1d3036.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/tshirt3new.png
// module id = 620
// module chunks = 0